module.exports = __webpack_public_path__ + "static/media/icon-user-fill.af36703f.svg";